import { ShareParticipantDTO } from './shareParticipant.dto';

export interface ShareInformationDTO {
    sharedAtDate: Date;
    sharedBy?: ShareParticipantDTO[];
    sharedWith?: ShareParticipantDTO[];
}
